import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  List,
  Typography,
  TextField,
  Card,
  DialogContentText,
  Grid,
  Menu,
  MenuItem,
  ListSubheader,
  Divider,
  Alert,
} from "@mui/material";

import FileOpenIcon from "@mui/icons-material/FileOpen";
import CloseIcon from "@mui/icons-material/Close";
import GetAppIcon from "@mui/icons-material/GetApp";
import SearchIcon from "@mui/icons-material/Search";

import {
  getPublicLayouts,
  getLastPublicLayouts,
  captureLayout,
} from "../../services/Layouts";
import { getGroupsByUser } from "../../services/Groups";

export default function GroupManager() {
  const [groups, setGroups] = useState([]);
  const [layouts, setLayouts] = useState([]);
  const [openShowModal, setOpenShowModal] = useState(false);
  const [search, setSearch] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [layoutId, setLayoutId] = useState(null);
  const [success, setSuccess] = useState(false);
  const [searchClicked, setSearchClicked] = useState(false);
  const openGroupMenu = Boolean(anchorEl);

  useEffect(() => {
    getLastLayouts();
    getGroups();
  }, []);

  const handleClickImport = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseGroupMenu = () => {
    setAnchorEl(null);
  };

  const getLayouts = () => {
    setSearchClicked(true);
    if (search.length < 4) {
      setLayouts([]);
      return;
    }
    getPublicLayouts(search)
      .then((response) => {
        setLayouts(response.data);
      })
      .catch(() => {
        //
      });
  };
  const getLastLayouts = () => {
    getLastPublicLayouts()
      .then((response) => {
        setLayouts(response.data);
      })
      .catch(() => {
        //
      });
  };

  const getGroups = () => {
    getGroupsByUser()
      .then((response) => {
        setGroups(response.data);
      })
      .catch(() => {
        //
      });
  };

  const handleCaptureLayout = (groupId) => {
    captureLayout({ layoutId, groupId }).then(() => {
      setSuccess(true);
    });
    handleCloseGroupMenu();
  };

  return (
    <>
      <Box p={2} sx={{ textAlign: "center" }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={10}>
            <TextField
              label="Pesquisar Layouts Públicos"
              variant="outlined"
              size="small"
              fullWidth
              onChange={(e) => setSearch(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  getLayouts();
                }
              }}
            />
          </Grid>
          <Grid item xs={2}>
            <Button
              variant="contained"
              fullWidth
              onClick={getLayouts}
              startIcon={<SearchIcon />}
            >
              Pesquisar {/* trad */}
            </Button>
          </Grid>
        </Grid>
      </Box>
      {success && (
        <Box p={2} sx={{ textAlign: "center" }}>
          <Alert variant="outlined" severity="success">
            Layout disponível em MEUS LAYOUTS {/* trad */}
          </Alert>
        </Box>
      )}
      <Box p={2} sx={{ textAlign: "center" }}>
        {!searchClicked && (
          <Typography variant="caption">
            Últimos layouts públicos adicionados: {/* trad */}
            <br />
            <br />
          </Typography>
        )}
        {searchClicked && layouts.length === 0 && (
          <Typography variant="caption">
            {
              search.length < 4 ? (
                "Digite ao menos 4 caracteres para pesquisar. " /* trad */
              ) : (
                <>
                  Nenhum layout encontrado para a pesquisa{" "}
                  <u>
                    <b>{search}</b>
                  </u>
                </>
              ) /* trad */
            }

            <br />
            <br />
          </Typography>
        )}
        <List>
          {layouts.map((layout) => (
            <Card key={layout.id} sx={{ mb: 1, p: 1 }}>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <table>
                  <tr>
                    <td>
                      <img
                        src={layout.icon}
                        style={{
                          maxWidth: "32px",
                          maxHeight: "32px",
                          display: "block",
                          marginRight: "10px",
                        }}
                      />
                    </td>
                    <td>
                      <Typography style={{ display: "inline-block" }}>
                        {layout.name}
                      </Typography>
                    </td>
                  </tr>
                </table>
                <Box>
                  {/*           <IconButton>
                    <FileOpenIcon />
                  </IconButton> */}
                  <IconButton
                    onClick={(e) => {
                      handleClickImport(e);
                      setLayoutId(layout.id);
                    }}
                  >
                    <GetAppIcon />
                  </IconButton>

                  <Menu
                    anchorEl={anchorEl}
                    open={openGroupMenu}
                    onClose={handleCloseGroupMenu}
                  >
                    <ListSubheader>
                      SELECIONE UM GRUPO {/* trad */}
                    </ListSubheader>

                    {groups &&
                      groups.map(
                        (group) =>
                          group.name !== "__dg_" && (
                            <MenuItem
                              key={group.id}
                              onClick={() => handleCaptureLayout(group.id)}
                            >
                              {group.name}
                            </MenuItem>
                          ),
                      )}
                    <Divider />
                    <MenuItem onClick={() => handleCaptureLayout(1)}>
                      Importar sem grupo{/* trad */}
                    </MenuItem>
                  </Menu>
                </Box>
              </Box>
            </Card>
          ))}
        </List>

        <Dialog open={openShowModal} onClose={() => setOpenShowModal(false)}>
          <DialogTitle>Exclusão de grupo {/* trad */}</DialogTitle>

          <DialogContent>
            <DialogContentText>
              Tem certeza que deseja excluir o grupo ?{/* trad */}
              <Box>
                <Typography variant="caption">
                  Os layouts associados NÃO SERÃO EXCLUÍDOS.{/* trad */}
                </Typography>
              </Box>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button>Capturar{/*trad */}</Button>
            <Button
              onClick={() => setOpenShowModal(false)}
              startIcon={<CloseIcon />}
            >
              Fechar{/*trad */}
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </>
  );
}
